/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Button, IconButton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import cn from "clsx";
import { ReactComponent as ClarityLogo } from "cms/assets/images/claritybc-logo.svg";
import { ReactComponent as MenuIcon } from "cms/assets/icons/menu.svg";
import { ReactComponent as XIcon } from "cms/assets/icons/x.svg";

const TopBar = (props) => {

    const headerNavLinks = props?.headerNavLinks;
    const scrollToSection = props?.scrollToSection;
    const showMobileMenu = props?.showMobileMenu;
    const toggleMobile = props?.toggleMobile;

    const menuButtonClassName = cn(
        "menu-button",
        { open: showMobileMenu }
    );
    const navigate = useNavigate();

    const handleOnClickSurvey = async () => {
        navigate("/survey");
    };

    return (
        <div className="header-top-bar">
            <Link to='/' className='clarity-logo'>
                <ClarityLogo
                    alt='clarity-logo'
                />
            </Link>
            <div className='header-nav-links'>
                {headerNavLinks.map((navLink) => {
                    return (
                        <Button key={navLink.title} onClick={() => scrollToSection(navLink.id)}>
                            {navLink.title}
                        </Button>
                    );
                })}
            </div>
            <div className='header-content-right'>
                {/*<Link to='/survey' className='clarity-logo'>*/}
                <Button
                    className='take-survey-btn'
                    variant='contained'
                    onClick={handleOnClickSurvey}
                >
                    Take Survey
                </Button>
                {/*</Link>*/}
                <IconButton className={menuButtonClassName} onClick={toggleMobile} >
                    {!showMobileMenu && <MenuIcon />}
                    {showMobileMenu && <XIcon />}
                </IconButton>
            </div>
        </div>
    );
};

export { TopBar };
